import { connectBaseApi, containerClient, createRpcMutation, createRpcQuery } from "@racoon/api";

const containerTypeGrpc = connectBaseApi.injectEndpoints({
  endpoints: (build) => ({
    listContainerTypes: createRpcQuery(build, containerClient, "listContainerTypes", {
      providesTags: ["ContainerType"],
    }),
    createContainerType: createRpcMutation(build, containerClient, "createContainerType", {
      invalidatesTags: ["ContainerType"],
    }),
    updateContainerType: createRpcMutation(build, containerClient, "updateContainerType", {
      invalidatesTags: ["ContainerType"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useListContainerTypesQuery,
  useCreateContainerTypeMutation,
  useUpdateContainerTypeMutation,
} = containerTypeGrpc;
